// extracted by mini-css-extract-plugin
export default {"selectBlock":"filter_selectBlock__+v4hg"};